module.exports = __webpack_public_path__ + "media/images/tl/banner/en-dark-d0384dfce755b5f547f36ede66d16b9a.jpg";